import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { TextField, Select, FormControl, MenuItem } from '@mui/material'
import Button from '@mui/material/Button';

import MuiDialogAlert from '../components/MuiDialogAlert';
import LoadingOverlay from 'react-loading-overlay-ts';

import { secsToTimeOfDay, epochToHumanReadableTS, secsToHumanReadable } from '../components/Functions'

import axios from 'axios';

import AdminMenu from '../components/AdminMenu'

const columns = [
    { field: 'task_type', headerName: 'Type', width: 100 },
    { field: 'req', headerName: 'Request' },
    { field: 'interval', headerName: 'Interval' },
    { field: 'start_time', headerName: 'Start Time' },
    { field: 'end_time', headerName: 'End Time' },
    { field: 'last_exec_time', headerName: 'Last Exec Time', width: 200 },
    { field: 'active', headerName: 'Active', width: 100 }
]

const col1_width = "100px";
const col2_width = "150px";
const col3_width = "50px";

const form_target_list = [
    "id",
    "device_id",
    "task_type", 
    "req", 
    "active", 
    "interval", 
    "interval_unit",
    "start_time_hr", 
    "start_time_min", 
    "end_time_hr", 
    "end_time_min",
    "title"
]

const default_form_vals = {
    "id":0,
    "device_id": "",
    "task_type": "TASK",
    "req": "READ_TOF",
    "active": "true",
    "interval": 0,
    "interval_unit": "days",
    "start_time_hr": 0,
    "start_time_min": 0,
    "end_time_hr": 0,
    "end_time_min": 0,
    "title": "New Task Schedule"
}

const AdminTaskSchedule = () => {

    let navigate = useNavigate();

    const [deviceList, setDeviceList] = useState([]);
    const [reqList, setReqList] = useState([]);
    const [deviceTaskSchedule, setDeviceTaskSchedule] = useState([])
    const [formData, setFormData] = useState(default_form_vals)
    const [selectedDeviceId,setSelectedDeviceId] = useState("")
    const [showDataDiv, setShowDataDiv] = useState("hidden")
    const [showEditDiv, setShowEditDiv] = useState("hidden")
    const [loadingActive, setLoadingActive] = useState(false);
    const [loadingText, setLoadingText] = useState("Loading");
    const [modalHeader, setModalHeader] = useState("");
    const [modalBody, setModalBody] = useState("Update Successful");
    const [showModal, setShowModal] = useState(false);    

    const handleClose = () => setShowModal(false);

    // Start up : Load the list of available devices
    useEffect(() => {
        const getDevices = async () => {
            try {
                // Make a GET request using Axios
                let url = process.env.REACT_APP_API_SERVER + "/getDevices";
                console.log(`URL: ${url}`);
                const response = await axios.get(url, {
                    params: {
                        "api_user": JSON.parse(localStorage.getItem('user'))
                    }
                });

                if (response.data.status === "API_AUTH_ERROR") {// Force user to re-login if unable to autheticate with the API
                    navigate("/logout")
                }

                console.log(response.data);
                // Set the retrieved data to the state
                setDeviceList(response.data);
                updateFormData("device_id", response.data[0].device_id)
            } catch (error) {
                // Handle errors if the request fails
                console.log(error);
                // setError(error);
               
            }
        };

        const getReqList = async () => {
            try {
                // Make a GET request using Axios
                let url = process.env.REACT_APP_API_SERVER + "/getReqList";
                console.log(`URL: ${url}`);
                const response = await axios.get(url, {
                    params: {
                        "api_user": JSON.parse(localStorage.getItem('user'))
                    }
                });
                if (response.data.status === "API_AUTH_ERROR") {
                    // Force user to re-login if unable to autheticate with the API
                    navigate("/logout")
                }
                console.log(response.data);
                // Set the retrieved data to the state
                setReqList(response.data);
            } catch (error) {
                // Handle errors if the request fails
                console.log(error);
                // setError(error);
               
            }
        };

        // Call the fetchData function when the component mounts

        setLoadingActive(true);
        getDevices();
        getReqList();
        setLoadingActive(false);


    }, [])

    function updateForm(e) {
        console.log(e)

        if (form_target_list.includes(e.target.id)) {
            console.log("id")
            console.log(e.target.id)
            console.log(e.target.value)
            updateFormData(e.target.id, e.target.value)
        }

        if (form_target_list.includes(e.target.name)) {
            console.log("name");
            console.log(e.target.name)
            console.log(e.target.value)
            updateFormData(e.target.name, e.target.value)
        }
        return

    }

    function updateFormData(id, val) {
        setFormData((prevFormData) => ({
            ...prevFormData,
            [id]: val,
        }));
    }

    function loadBtnClick(e){
        loadTaskSchedule()
    }

    function loadTaskSchedule(){
        let url = process.env.REACT_APP_API_SERVER + "/loadTaskSchedule";
        let post_data = {}
        post_data.device_id = formData.device_id

        axios.post(url, post_data)
            .then(function (response) {
                let data = response.data;

                console.log(data)

                let tmp_array = []
                data.map((task) => {
                    let tmp_json = {}
                    tmp_json.id = task.id
                    tmp_json.req = task.req
                    tmp_json.task_type = task.task_type
                    tmp_json.active = task.active
                    tmp_json.interval = secsToHumanReadable(task.interval)
                    tmp_json.start_time = secsToTimeOfDay(task.start_time)
                    tmp_json.end_time = secsToTimeOfDay(task.end_time)
                    tmp_json.last_exec_time = epochToHumanReadableTS(task.last_exec_time)
                    tmp_array.push(tmp_json)

                });

                setDeviceTaskSchedule(tmp_array)
                setSelectedDeviceId(formData.device_id)
                setShowDataDiv("")

                // setLoadingActive(false)
            })
            .catch(function (error) {
                // setModalHeader("Error: Unable to Generate Report")
                // setModalBody(error)
                // setShowModal(true)
            });        
    }

    function updateBtnClick(e){
        let url = process.env.REACT_APP_API_SERVER + "/updateTaskSchedule";
        let post_data = formData

        setLoadingText("Updating Database ...")
        setLoadingActive(true)

        axios.post(url, post_data)
            .then(function (response) {
                let data = response.data;
                console.log(data)
                // if (response.data.status === "API_AUTH_ERROR") {
                //     // Force user to re-login if unable to autheticate with the API
                //     navigate("/logout")
                // }
                setLoadingText("Updating Task Schedule ...")
                loadTaskSchedule()
                setShowEditDiv("hidden")
                setLoadingActive(false)
            })
            .catch(function (error) {
                setModalHeader("Error: Unable to Update Task")
                setModalBody(error)
                setShowModal(true)
            });        
    }

    function newTaskScheduleClick(){
        console.log("newTaskSchedule")
        let device_id = formData.device_id;
        setFormData(default_form_vals)
        updateFormData("device_id", device_id)
        setShowEditDiv("")

    }

    function taskScheduleRowClick(e){
        let data = e.row

        console.log(data)

        // Split interval into units and time
        const parts_1 = data.interval.split(' ');
        updateFormData("interval", parts_1[0])
        updateFormData("interval_unit", parts_1[1])

        // Split start_time into hours and mins
        const parts_2 = data.start_time.split(':');
        updateFormData("start_time_hr", parts_2[0])
        updateFormData("start_time_min", parts_2[1])

        // Split end_time into hours and mins
        const parts_3 = data.end_time.split(':');
        updateFormData("end_time_hr", parts_3[0])
        updateFormData("end_time_min", parts_3[1])

        updateFormData("id", data.id)
        updateFormData("req", data.req)
        updateFormData("active", data.active)
        updateFormData("task_type", data.task_type)

        updateFormData("title", "Edit Data")

        setShowEditDiv("")
    }

    return (
        <div align="left" style={{ height: "100%", padding: "30px" }} className='admin_pages'>
            <LoadingOverlay
                active={loadingActive}
                spinner
                text={loadingText}
                className="spinner_div"
            >
            
            <AdminMenu />

            {/* Drop down menu to select device  */}
            <table width="800px">
                <tr>
                    <td>
                        <div className="form-labels-admin">Select Device</div>
                        <FormControl fullWidth>
                            <Select
                                id="device_id"
                                name="device_id"
                                label="Select Device"
                                value={formData.device_id}
                                variant="outlined"
                                onChange={updateForm}
                                sx={{
                                    '& legend': { display: 'none' },
                                    '& fieldset': { top: 0 },
                                    ' & .MuiSelect-select': { fontSize: 14 }
                                }}
                            >
                                {
                                    deviceList.map(device => {
                                        return <MenuItem key={device.device_id} value={device.device_id}>
                                            {device.device_id}
                                        </MenuItem>
                                    })
                                }
                            </Select>
                        </FormControl>
                    </td>
                    <td>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={loadBtnClick}
                            sx={{ width: 100, height: 50 }}
                            style={{ marginTop: "20px" }}
                        >
                            Load
                        </Button>
                    </td>
                    <td>
                        <Button
                            variant="contained"
                            color="info"
                            onClick={newTaskScheduleClick}
                            sx={{ width: 200, height: 50 }}
                            style={{ marginTop: "20px" }}
                        >
                            New Task Schedule
                        </Button>
                    </td>
                </tr>
            </table>

                <div style={{ height: "20px" }}></div>

            <table>
                <tr>
                    <td valign="top"> {/* Data Grid -- List of tasks  */}        
                        <div className={showDataDiv}>
                                <div className='form_title'>
                                    <table width="800px">
                                        <tr>
                                            <td align="left">Task Schedule</td>
                                            <td align="right" style={{ fontSize: "24px" }}>{selectedDeviceId}</td>
                                        </tr>
                                    </table>
                                </div>

                            <div style={{ height: 400, width: 800 }}>
                                <DataGrid
                                    rows={deviceTaskSchedule}
                                    columns={columns}
                                    pageSize={50}
                                    onRowClick={taskScheduleRowClick}
                                    disableVirtualization
                                    disableSelectionOnClick
                                    components={{ Toolbar: GridToolbar }}
                                    sx={{
                                        '& .MuiTablePagination-selectLabel': {
                                            paddingTop: '15px'

                                        },
                                        '& .MuiTablePagination-displayedRows': { paddingTop: '15px' },
                                        '& .MuiDataGrid-cell': { fontSize: 12 },
                                        '& .MuiDataGrid-columnHeader': { fontSize: 12 },
                                        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell--editing': {
                                            outline: 'none', // Remove outline when cell is focused or editing
                                            border: 'none', // Remove border when cell is focused or editing
                                        }

                                    }} />
                            </div>
                        </div>
                    </td>
                    <td width="30px"></td>
                        <td valign="top">
                            {/* Form -- Add/Edit task schedule   */}
                            <div className={showEditDiv}>

                                <div className='form_title'>{formData.title}</div>

                                <div className='form-row-admin'> {/* TYPE */}
                                    <table>
                                        <tr>
                                            <td valign="center" width={col1_width} className="form-labels-labels valign-center">Type</td>
                                            <td align='left' width={col2_width} className='valign-center'>
                                                <TextField
                                                    id="task_type"
                                                    name="task_type"
                                                    onChange={updateForm}
                                                    variant="outlined"
                                                    value={formData.task_type}
                                                    size="small"
                                                    sx={{
                                                        '& legend': { display: 'none' },
                                                        '& fieldset': { top: 0 },
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div className='form-row-admin'> {/* REQUEST */}
                                    <table>
                                        <tr>
                                            <td valign="center" width={col1_width} className="form-labels-labels valign-center">Request</td>
                                            <td align='left' width={col2_width} className='valign-center'>
                                                <FormControl sx={{ m: 1, minWidth: 50, margin: 0 }} size="small" fullWidth>
                                                    <Select
                                                        id="req"
                                                        name="req"
                                                        label="req"
                                                        value={formData.req}
                                                        variant="outlined"
                                                        onChange={updateForm}
                                                        sx={{
                                                            '& legend': { display: 'none' },
                                                            '& fieldset': { top: 0 },
                                                            ' & .MuiSelect-select': { fontSize: 14 }
                                                        }}
                                                    >
                                                        {
                                                            reqList.map(req => {
                                                                return <MenuItem key={req.req} value={req.req}>
                                                                    {req.req}
                                                                </MenuItem>
                                                            })
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div className='form-row-admin'> {/* INTERVAL */}
                                    <table>
                                        <tr>
                                            <td valign="center" width={col1_width} className="form-labels-labels valign-center">Interval</td>
                                            <td align='left' width={col3_width} className='valign-center'>
                                                <TextField
                                                    id="interval"
                                                    onChange={updateForm}
                                                    variant="outlined"
                                                    value={formData.interval}
                                                    size="small"
                                                    sx={{
                                                        '& legend': { display: 'none' },
                                                        '& fieldset': { top: 0 },
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                <FormControl sx={{ m: 1, minWidth: 50, margin: 0 }} size="small" fullWidth>
                                                    <Select
                                                        id="interval_unit"
                                                        name="interval_unit"
                                                        label="Select Device"
                                                        value={formData.interval_unit}
                                                        variant="outlined"
                                                        onChange={updateForm}
                                                        sx={{
                                                            '& legend': { display: 'none' },
                                                            '& fieldset': { top: 0 },
                                                            ' & .MuiSelect-select': { fontSize: 14 }
                                                        }}
                                                    >
                                                        <MenuItem key='days' value='days'>Days</MenuItem>
                                                        <MenuItem key='hours' value='hours'>Hours</MenuItem>
                                                        <MenuItem key='mins' value='mins'>Mins</MenuItem>
                                                        <MenuItem key='secs' value='secs'>Seconds</MenuItem>
                                                    </Select>
                                                </FormControl>

                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div className='form-row-admin'> {/* START TIME */}
                                    <table>
                                        <tr>
                                            <td valign="center" width={col1_width} className="form-labels-labels valign-center">Start Time</td>
                                            <td align='left' width={col3_width} className='valign-center'>
                                                <TextField
                                                    id="start_time_hr"
                                                    onChange={updateForm}
                                                    variant="outlined"
                                                    value={formData.start_time_hr}
                                                    size="small"
                                                    sx={{
                                                        '& legend': { display: 'none' },
                                                        '& fieldset': { top: 0 },
                                                    }}
                                                />
                                            </td>
                                            <td>:</td>
                                            <td align='left' width={col3_width} className='valign-center'>
                                                <TextField
                                                    id="start_time_min"
                                                    onChange={updateForm}
                                                    variant="outlined"
                                                    value={formData.start_time_min}
                                                    size="small"
                                                    sx={{
                                                        '& legend': { display: 'none' },
                                                        '& fieldset': { top: 0 },
                                                    }}
                                                />
                                            </td>
                                            <td>hrs</td>
                                        </tr>
                                    </table>
                                </div>
                                <div className='form-row-admin'> {/* END TIME */}
                                    <table>
                                        <table>
                                            <tr>
                                                <td valign="center" width={col1_width} className="form-labels-labels valign-center">End Time</td>
                                                <td align='left' width={col3_width} className='valign-center'>
                                                    <TextField
                                                        id="end_time_hr"
                                                        onChange={updateForm}
                                                        variant="outlined"
                                                        value={formData.end_time_hr}
                                                        size="small"
                                                        sx={{
                                                            '& legend': { display: 'none' },
                                                            '& fieldset': { top: 0 },
                                                        }}
                                                    />
                                                </td>
                                                <td>:</td>
                                                <td align='left' width={col3_width} className='valign-center'>
                                                    <TextField
                                                        id="end_time_min"
                                                        onChange={updateForm}
                                                        variant="outlined"
                                                        value={formData.end_time_min}
                                                        size="small"
                                                        sx={{
                                                            '& legend': { display: 'none' },
                                                            '& fieldset': { top: 0 },
                                                        }}
                                                    />
                                                </td>
                                                <td>hrs</td>
                                            </tr>
                                        </table>
                                    </table>
                                </div>
                                <div className='form-row-admin'> {/* ACTIVE */}
                                    <table>
                                        <tr>
                                            <td valign="center" width={col1_width} className="form-labels-labels valign-center">Active</td>
                                            <td>
                                                <FormControl sx={{ m: 1, minWidth: 50, margin: 0 }} size="small" fullWidth>
                                                    <Select
                                                        id="active"
                                                        name="active"
                                                        label="active"
                                                        value={formData.active}
                                                        variant="outlined"
                                                        onChange={updateForm}
                                                        sx={{
                                                            '& legend': { display: 'none' },
                                                            '& fieldset': { top: 0 },
                                                            ' & .MuiSelect-select': { fontSize: 14 }

                                                        }}
                                                    >
                                                        <MenuItem key='true' value='true'>True</MenuItem>
                                                        <MenuItem key='false' value='false'>False</MenuItem>
                                                    </Select>
                                                </FormControl>

                                            </td>
                                        </tr>
                                    </table>
                                </div>

                                <div className='form-row-admin'>
                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={updateBtnClick}
                                        sx={{ width: 200, height: 50 }}
                                        style={{ marginTop: "20px" }}
                                    >
                                        Update/Save
                                    </Button>

                                </div>

                            </div>


                    </td>
                </tr>

            </table>


            <div style={{height:"20px"}}></div>
            
            <MuiDialogAlert
                showModal={showModal}
                handleClose={handleClose}
                bodyContent={modalBody}
                title={modalHeader}
                bodyClass="whitespace"
            />


            </LoadingOverlay>
        </div>
    )
}

export default AdminTaskSchedule